import { Text, Range } from 'domains/reporter/RichTextEditor/core';
import type { EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';
import type { ParsedDictationChunkExternalSubstitutionPayload } from './NvoqQueue/createNvoqWebsocketFactory';
import type { RecorderTarget } from 'common/Recorder/useRecorder';

export const DICTATION_PLUGIN_ID = 'dictation' as const;
export type DictationPluginID = typeof DICTATION_PLUGIN_ID;

export const DICTATION_ID_TEXT_MARK = 'dictationId' as const;
export type DictationIdTextMark = typeof DICTATION_ID_TEXT_MARK;

export const DICTATION_INDEX_TEXT_MARK = 'dictationIndex' as const;
export type DictationIndexTextMark = typeof DICTATION_INDEX_TEXT_MARK;

export type DictationPluginElementOrDecorate = Readonly<
  Text & {
    selectionRef: Range;
    hypothesisText: string;
    type: DictationPluginID;
  }
>;

export type RecorderVoiceCommandProps = Readonly<{
  type: 'RecorderVoiceCommand';
  /**
   * Selection at the point in which the user dictated the substitution, not necessarily
   * where the user's current selection is!
   */
  selection: Range;
  substitution: ParsedDictationChunkExternalSubstitutionPayload;
}>;

export type OnExternalSubstitution = (props: RecorderVoiceCommandProps) => void;

export type DictationPluginOptions = Readonly<
  EditorPluginOptions & {
    nvoqID: string;
    nvoqAuthorization: string;
    target: RecorderTarget;
    enablePicklistDictation?: boolean;
    component?: ComponentType<any>;
    getActiveTemplateId?: () => string | undefined;
  }
>;

export type DictationPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    DictationPluginOptions & {
      pluginName: string;
      pluginID: DictationPluginID;
      nvoqID: string;
      nvoqAuthorization: string;
      target: RecorderTarget;
      enablePicklistDictation: boolean;
      component: ComponentType<any>;
    }
>;

export type WebsocketCreationOptions = {
  shouldSkipWebsocketCreation: boolean;
};
